export default __webpack_public_path__ + "static/media/patteren-img.5403e587.png";